/**
 * @fileoverview Dashboard index route configuration
 * Renders the main dashboard overview page with key metrics and summaries
 */

// Library imports
import { createFileRoute } from "@tanstack/react-router";

// Page components
import HomePage from "@/features/dashboard/pages/home";

/**
 * Route configuration for the main dashboard page
 * Uses TanStack Router's file-based routing system
 */
export const Route = createFileRoute("/(app)/dashboard/")({
  component: HomePage,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h1 className="font-display text-2xl text-brand">Could not load home</h1>
      <pre className="mt-4 whitespace-pre-wrap text-[13px] text-muted-foreground">{error.message}</pre>
    </div>
  ),
});
